import { $$ } from 'utils/select';

function cookiehubDialog() {
  let $$links = [];

  function init() {
    $$links = $$('.js-cookiehub');
    if (!$$links.length) return;

    $$links.forEach(($el) => {
      $el.addEventListener('click', handleClick);
    });
  }

  function handleClick(e) {
    e.preventDefault();
    if (window.cookiehub) {
      window.cookiehub.openSettings();
    } else {
      window.alert(window.blockerWarning);
    }
  }

  function destroy() {
    if (!$$links.length) return;

    $$links.forEach(($el) => {
      $el.removeEventListener('click', handleClick);
    });

    $$links = [];
  }

  return { init, destroy };
}

export default cookiehubDialog();
